import React from "react";
import { Legs } from "components/src/components/Legs/Legs";
import { LegType } from "components/src/components/Legs/types";
import { EventDetailsType } from "../../EventDetails/types";

export const QuickPickLegs = ({
  computedLegs,
}: {
  computedLegs: any;
}) => {
  return (
    <div className="cui-flex-grow" role="group">
      <Legs legs={computedLegs} aria-label={`Quick Pick`} testId="quick-pick-selections" legTestId="quick-pick-selection" tabbable={false} />
    </div>
  );
};
